module.exports = __webpack_public_path__ + "img/grey-card.68b8c583.png";